export default __webpack_public_path__ + "static/media/Laptop_Portfolio.5e328559.mp4";